import React from 'react'
import { Rings } from 'react-loader-spinner'
import { Card, Row, Col } from 'react-bootstrap'

const CURRENT_STEP = 'PENDING';

export default function Pending({ step }) {

  if (step !== CURRENT_STEP) {
    return null
  }

  return <Row>
    <Col className='px-0'>
      <Card style={{ height: '741px' }}>
        <Card.Body >
          <Row className='h-100'>
            <Col className='text-center' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' }}>
              <Rings height='200' width='200' color='#1AB2E9' arialLabel="loading-indicator" wrapperStyle={{ justifyContent: 'center' }} />
              <br />
              <h1 className='pb-5 font-weight-light'>Creating your landing page...</h1>
              <p>You may navigate away while we're creating the landing page. We'll send you an email once the page has been created.</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row >
}